import { getResource } from "../api/http";

// Revenue dashboard ("transactions" section): subscribers, MRR, months,
// countries, upcoming renewals, cancellation reasons.
const query = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "");
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : "";
};

/** `{ months, currency }`; rejects on failure. */
export const getRevenue = (params) => getResource(`/api/admin/revenue${query(params)}`, { rethrow: true });
